import { EventModel, EventScoreboard, SetGameScore } from '@frontend/sports/betting-offer/feature/model';

import { MyBetsEventModel } from '../../my-bets/models/my-bets-event.model';
import { ScoreboardStat, SetGameScoreboardStats } from './scoreboard-stats';
import { SetScoreboardViewModel } from './set-scoreboard.viewmodel';

export class BaseBallscoreboardViewModel extends SetScoreboardViewModel {
    isActive: boolean;
    activeCurrentInning: number;
    participant1runs: string;
    participant2runs: string;

    protected override __fillFromEvent(event: EventModel | MyBetsEventModel): void {
        super.__fillFromEvent(event);
        this.updateFromScoreboard(event.scoreboard);
    }

    override updateFromScoreboard(scoreboard: EventScoreboard): void {
        super.updateFromScoreboard(scoreboard);

        if (!scoreboard.period) {
            return;
        }

        const score = scoreboard.getScore<SetGameScore>()!;
        this.activeCurrentInning = Number(scoreboard.period.name.replace(/\D/g, ''));

        if (score.participant1 && score.participant1.points) {
            this.participant1runs = score.participant1.points;
            this.participant2runs = score.participant2.points!;
        }
    }

    isHighlighedSet(index: number, player: number): boolean {
        if (index === this.activeCurrentInning - 1) {
            if (index < 0 || index >= this.sets.list.length) {
                return false;
            }
            const isFinished = this.isSetFinished(index);
            if (!isFinished) {
                return true;
            }

            return (
                (player === 1 && this.sets.list[index].player1 > this.sets.list[index].player2) ||
                (player === 2 && this.sets.list[index].player1 < this.sets.list[index].player2) ||
                (this.sets.list[index].player1 === this.sets.list[index].player2 && +this.sets.list[index].player1 > -1)
            );
        }

        return false;
    }

    protected override fillEmptySets(stats: SetGameScoreboardStats, score: SetGameScore): void {
        while (stats.sets.list.length < 9) {
            const order = stats.sets.list.length;
            stats.sets.addStat(new ScoreboardStat(`${this.setsKey}_${order}`, '-', '-', order, true));
        }
    }

    private isSetFinished(indx: number): boolean {
        if (indx === this.sets.list.length - 1) {
            return !this.isActive;
        }

        return +this.sets.list[indx + 1].player1 > -1 || +this.sets.list[indx + 1].player2 > -1;
    }
}
